import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { actionCreators } from "../redux/sagas/userMenu/userMenu";

export function TOSModal() {
  const dispatch = useDispatch();
  const { id: currentUserId, acceptedTosAt } = useSelector((state) => {
    return state.userMenu.currentUser;
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [acceptedTOS, setAcceptedTOS] = useState(false);

  const getParent = () => document.querySelector("body");

  const getTOS = () => {
    $(".tos-modal-wrapper").load("/tos #ikizmet_tos");
  };

  useEffect(() => {
    if (acceptedTosAt === null) {
      setModalOpen(true);
    }
  }, [acceptedTosAt]);

  const handleModalNext = () => {
    if (acceptedTOS) {
      dispatch(actionCreators.userAcceptTOS(currentUserId));
      setModalOpen(false);
    } else {
      setAcceptedTOS(true);
      jQuery(function ($) {
        $(".tos-modal-wrapper").load("/privacy #privacy");
        $(".tosModal").scrollTop(0);
      });
    }
  };

  return (
    <Modal
      ariaHideApp={false}
      parentSelector={getParent}
      className="tosModal custom-scroll-bar"
      closeTimeoutMS={500}
      isOpen={modalOpen}
      // onRequestClose={this.closeModal}
      onAfterOpen={getTOS}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 10000
        },
        content: {
          position: "absolute",
          top: "5%",
          left: "10px",
          width: "96vw",
          height: 500,
          bottom: 40,
          backgroundColor: "white",
          borderRadius: "10px",
          border: "solid 1px #444",
          padding: "25px",
          outline: "none",
          zIndex: 100000,
          overflow: "hidden",
          overflowY: "scroll"
        }
      }}
      contentLabel="TOS Modal"
    >
      <p style={{ textAlign: "center" }}>
        OUR TERMS OF SERVICE AND PRIVACY POLICY WERE RECENTLY UPDATED.
        <br />
        PLEASE AGREE TO UPDATED TERMS TO CONTINUE USING IKIZMET.
      </p>
      <div className="tos-modal-wrapper" />

      <button onClick={handleModalNext}>AGREE</button>
    </Modal>
  );
}
